import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { AddFolderButton, SmallScreenModel } from "components";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from "../../props/enum";
import Loading from "layout/components/Loading";
import BreadcrumbFolderLayout from "modules/video/components/BreadcrumbFolderLayout";
import { fetchAvaterImage } from "./store/action";
import { AvatarImageProps } from "./store/actionType";
import CreateAvatar from "./page/CreateAvatar";
import { Hand } from "lucide-react";
import HandleDeleteAvatar from "./page/HandleDeleteAvatar";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const Avatar: React.FC<Props> = ({ onFetchAvatarImage, avatarImageState }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    onFetchAvatarImage();
  }, []);
  const breadcrumbItem = [{ group: "Avatar", root: "Image" }];
  const { authUser, action, superAdmin } = useUser();

  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin ||
      action?.includes(Authorities.CREATE_GROUP));
  return (
    <div className="h-full overflow-hidden">
      {avatarImageState.isLoading && <Loading />}
      <BreadcrumbFolderLayout
        groupData={avatarImageState?.avatarsImage}
        breadcrumbItem={breadcrumbItem}
        addFolderButton={
          <>
            {isPermitted && (
              <AddFolderButton
                onClick={() => {
                  setModalOpen(true);
                }}
              >
                Upload Avatar
              </AddFolderButton>
            )}
          </>
        }
        folders={
          <>
            <div className="grid grid-cols-6 gap-4">
              {avatarImageState?.avatarsImage &&
                avatarImageState?.avatarsImage?.map(
                  (item: AvatarImageProps) => (
                    <div key={item?.id} className="relative group">
                      <img
                        src={`${item?.avatar_image_url}`}
                        alt="avatar"
                        className="w-full h-auto rounded-lg" 
                      />

                      <div className="absolute top-2 right-2">
                        <HandleDeleteAvatar
                          avatar_id={item?.id}
                          imageUrl={item?.avatar_image_url}
                        />
                      </div>
                    </div>
                  )
                )}
            </div>
          </>
        }
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <CreateAvatar closeModal={closeModal} />
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  avatarImageState: state.avatarImageReducer.avatarImageState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchAvatarImage: () => dispatch(fetchAvaterImage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Avatar);
